var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomeCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    d: "M25.563,13.063a12.5,12.5,0,1,1-12.5-12.5A12.5,12.5,0,0,1,25.563,13.063ZM11.617,19.681l9.274-9.274a.806.806,0,0,0,0-1.14l-1.14-1.14a.806.806,0,0,0-1.141,0l-7.563,7.563L7.515,12.158a.807.807,0,0,0-1.141,0L5.234,13.3a.806.806,0,0,0,0,1.14l5.242,5.242a.806.806,0,0,0,1.141,0Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeCheckCircle);
export default __webpack_public_path__ + "static/media/Icon awesome-check-circle.95ee5430feb2058cd42928e7698e5b6d.svg";
export { ForwardRef as ReactComponent };